import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import "./index.css";
// import "./components/museo_font/stylesheet.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { MyProvider } from './components/Provider/CommonProvider';
import TourProvider from './components/Tour/TourProvider';
import store from "./redux/store";


ReactDOM.render(
  <Suspense>
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <MyProvider>
            <TourProvider>
              <App />
            </TourProvider>
          </MyProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  </Suspense>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();